import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useNewProfileSpecialistCreateStyles = makeStyles((theme) =>
  createStyles({
    root: {
      marginTop: '100px',
      [theme.breakpoints.down(900)]: {
        marginTop: '30px'
      }
    },
    progressLabel: {
      fontSize: '18px',
      lineHeight: 'normal',
      fontWeight: 400,
      marginBottom: '16px',
      [theme.breakpoints.down(900)]: {
        fontSize: 15
      }
    },
    progressRoot: {
      backgroundColor: '#F6F6F4',
      height: '8px',
      borderRadius: '8px'
    },
    percent: {
      fontWeight: 600
    },
    stateInfo: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch',
      gap: '24px',
      [theme.breakpoints.down(900)]: {
        padding: '0 16px',
        gap: 16
      }
    },
    heading: {
      fontSize: '46px',
      fontWeight: 600,
      fontStyle: 'normal',
      lineHeight: 'normal',
      marginTop: '8px',
      [theme.breakpoints.down(900)]: {
        fontSize: '24px'
      }
    },
    description: {
      fontSize: '24px',
      fontWeight: 500,
      lineHeight: '36px',
      [theme.breakpoints.down(900)]: {
        fontSize: '16px',
        lineHeight: '24px'
      }
    },
    card: {
      backgroundColor: '#F6F6F4',
      borderRadius: '16px',
      padding: '56px 80px',
      [theme.breakpoints.down(1080)]: {
        padding: '32px 40px'
      }
    },
    formGridRoot: {
      [theme.breakpoints.down(900)]: {
        padding: '16px 0 !important'
      }
    },
    formWrapper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch',
      gap: '24px'
    },
    avatarWrapper: {
      display: 'flex',
      flexFlow: 'row nowrap',
      justifyContent: 'center'
    },
    avatar: {
      width: 128,
      height: 128
    },
    editIcon: {
      position: 'absolute',
      bottom: 0,
      right: 0
    },
    dobInputWrapper: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      gap: '16px',
      maxHeight: '56px',
      [theme.breakpoints.down(900)]: {
        flexWrap: 'wrap',
        maxHeight: '100%',
        rowGap: '16px'
      }
    },
    selector: {
      flex: '1 0 120px',
      maxHeight: '56px'
    },
    dobLabel: {
      display: 'block',
      fontSize: '16px',
      fontWeight: 600,
      lineHeight: 'normal',
      marginBottom: '16px',
      [theme.breakpoints.down(900)]: {
        fontSize: '14px'
      }
    },
    dobLabelLocation: {
      display: 'block',
      fontSize: '16px',
      fontWeight: 600,
      lineHeight: 'normal',
      [theme.breakpoints.down(900)]: {
        fontSize: '14px'
      }
    },
    dobError: {
      color: theme.palette.secondary.main,
      fontSize: '14px',
      marginTop: '10px'
    },
    inputStack: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch',
      gap: 16
    },
    formActions: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginTop: '56px'
    },
    chipRow: {
      display: 'flex',
      flexFlow: 'row wrap',
      gap: '12px'
    },
    chipRoot: {
      height: '40px',
      backgroundColor: '#E8E8E5',
      padding: '11px 16px',
      borderRadius: 24
    },
    chipLabel: {
      fontSize: '14px',
      fontWeight: 600,
      lineHeight: 'normal',
      padding: 0,
      color: '#7A7A75'
    },
    chipLabelContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: '12px',
      '& svg': {
        cursor: 'pointer'
      }
    },
    buttonRoot: {
      padding: '14px 38px',
      [theme.breakpoints.down(900)]: {
        padding: '12px 32px'
      }
    },
    buttonLabel: {
      fontSize: '16px',
      fontWeight: 600,
      lineHeight: 'normal',
      textTransform: 'none',
      [theme.breakpoints.down(900)]: {
        fontSize: '14px'
      }
    },
    skillChips: {
      marginTop: 16
    },
    checkBox: {
      '& .MuiFormControlLabel-label': {
        fontSize: 16
      }
    },
    success: {
      // maxWidth: 643,
      // display: 'flex',
      // flexDirection: 'column',
      // alignItems: 'center',
      // gap: 24,
      // // // padding: '64px 112px',
      // borderRadius: 12
      // border: '1px solid #E8E8E5',
      // boxShadow: '0px 8px 24px 0px rgba(0, 0, 0, 0.04)'
    },
    dialogCard: {
      borderRadius: '12px',
      border: '1px solid #E8E8E5'
    },
    wrapper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 24,
      padding: '64px 112px',
      borderRadius: 12,
      [theme.breakpoints.down(640)]: {
        padding: '40px 32px'
      }
    },
    header: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      width: '100%'
    },
    successText: {
      fontSize: 28,
      fontWeight: 600
    },
    successDesc: {
      textAlign: 'center',
      fontSize: 18
    },
    successProgress: {
      maxWidth: 416,
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      gap: 16,
      padding: 24,
      borderRadius: 12,
      border: '1px solid #F6F6F4'
    },
    successProgressBlock: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    successProgressText: {
      fontSize: 16,
      fontWeight: 600
    },
    successProgressPercent: {
      fontSize: 16,
      fontWeight: 600
    },
    successButton: {
      fontSize: 16,
      fontWeight: 600,
      textTransform: 'none',
      width: 240,
      height: 48
    },

    successButtonMy: {
      fontSize: 16,
      fontWeight: 600,
      textTransform: 'none',
      width: 240,
      height: 48,
      border: '1px solid #7A7A75'
    },
    avatarError: {
      paddingTop: '16px',
      width: '100%',
      textAlign: 'center',
      color: theme.palette.secondary.main,
      fontSize: '14px',
      marginTop: '10px'
    }
  })
)
